/**
 * Canonical metric formatting functions.
 * All components should import from here — do not duplicate these locally.
 */

function hasMeaningfulDecimals(value) {
  return Number.isFinite(value) && !Number.isInteger(value);
}

export function formatMetricValue(amount, unit = '', pendingReason = null, formatType = '') {
  if (!Number.isFinite(amount)) {
    return pendingReason || 'Not yet recorded';
  }

  if (formatType === 'currency' || unit === '$') {
    const decimalPrecision = hasMeaningfulDecimals(amount) ? 2 : 0;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: decimalPrecision,
      maximumFractionDigits: decimalPrecision
    }).format(amount);
  }

  if (formatType === 'percent' || unit === '%') {
    return formatPercent(amount, pendingReason);
  }

  const decimals = hasMeaningfulDecimals(amount) ? 2 : 0;
  return `${amount.toFixed(decimals)}${unit ? ` ${unit}` : ''}`;
}

export function formatGoalMetricValue(amount, unit = '', formatType = '') {
  if (!Number.isFinite(amount)) {
    return 'Unassigned';
  }

  return formatMetricValue(amount, unit, null, formatType);
}

export function formatPercent(value, pendingReason = null) {
  if (!Number.isFinite(value)) {
    return pendingReason || 'Not yet recorded';
  }

  return `${value.toFixed(value >= 100 ? 0 : 1)}%`;
}

export function formatGoalPercent(value, hasGoal = true) {
  if (!hasGoal) {
    return 'Unassigned';
  }

  return formatPercent(value);
}
